import type { FormaLanguage } from './language-policy';
import type { RoutineFocusAreaId, RoutinePurposeId } from '@forma/domain';

const routinePurposeLabels: Record<
  FormaLanguage,
  Record<RoutinePurposeId, string>
> = {
  en: {
    endurance: 'Endurance',
    general: 'General',
    mobility: 'Mobility',
    recovery: 'Recovery',
    rehab: 'Rehab',
    speed_power: 'Speed & Power',
    strength: 'Strength',
    warmup: 'Warmup',
  },
  pl: {
    endurance: 'Wytrzymałość',
    general: 'Ogólne',
    mobility: 'Mobilność',
    recovery: 'Regeneracja',
    rehab: 'Rehabilitacja',
    speed_power: 'Szybkość i moc',
    strength: 'Siła',
    warmup: 'Rozgrzewka',
  },
};

const routineFocusAreaLabels: Record<
  FormaLanguage,
  Record<RoutineFocusAreaId, string>
> = {
  en: {
    ankles_feet: 'Ankles / feet',
    back_spine: 'Back / spine',
    core: 'Core',
    full_body: 'Full body',
    hips: 'Hips',
    knees: 'Knees',
    lower_body: 'Lower body',
    shoulders: 'Shoulders',
    upper_body: 'Upper body',
  },
  pl: {
    ankles_feet: 'Kostki / stopy',
    back_spine: 'Plecy / kręgosłup',
    core: 'Mięśnie tułowia',
    full_body: 'Całe ciało',
    hips: 'Biodra',
    knees: 'Kolana',
    lower_body: 'Dolna część ciała',
    shoulders: 'Barki',
    upper_body: 'Górna część ciała',
  },
};

export function getRoutinePurposeLabel(
  language: FormaLanguage,
  purposeId: RoutinePurposeId,
) {
  return routinePurposeLabels[language][purposeId];
}

export function getRoutineFocusAreaLabel(
  language: FormaLanguage,
  focusAreaId: RoutineFocusAreaId,
) {
  return routineFocusAreaLabels[language][focusAreaId];
}
